export const MARKETPLACE_ENABLED = import.meta.env.VITE_MARKETPLACE_ENABLED !== 'false';
